// extracted by mini-css-extract-plugin
export default {"container":"mq-z","paperCuts":"nq-z","brandName":"oq-z","productName":"pq-z","breakLongProductName":"qq-z"};